export const TypeNotifications = {
    AUTHENTICATION : "AUTHENTICATION",
    ACTIVITY_MAKE : "ACTIVITY_MAKE",
    SESSION : "SESSION",
    GETMESSAGES : "GETMESSAGES",
}